import { Flex, Heading, Text } from "@chakra-ui/react";
import { OnboardingSetupStep } from "components/Onboarding/SetupStepTile";
import { APP_NAME } from "utils/config";
import { useCurrentUserData } from "utils/currentUserHooks";
import { formatInteger } from "utils/formatting";

type Props = {
  completedCount: number | undefined;
  steps: OnboardingSetupStep[];
};

export default function SetupGuideHeader({ completedCount, steps }: Props) {
  const userData = useCurrentUserData();
  const { firstName } = userData || {};

  return (
    <>
      <Flex alignItems="center" gap={2}>
        <Text
          color="pink.500"
          fontSize="xs"
          fontWeight="700"
          textTransform="uppercase"
        >
          Get Started
        </Text>
        {completedCount !== undefined && (
          <Text color="gray.400" fontSize="xs" fontWeight="400">
            {formatInteger(completedCount)} of {formatInteger(steps.length)}{" "}
            done
          </Text>
        )}
      </Flex>
      <Heading as="h2" size="lg" color="magenta.veryDark" mt={1}>
        Welcome to {APP_NAME}
        {firstName ? `, ${firstName}` : ""}
      </Heading>
    </>
  );
}
